import styled from "styled-components";

export const StyledModal = styled.div`
  position: relative;
  top: 0;
  left: 0;
  z-index: 4;
`;
